export const HOME_PATH = '/'
export const ADVERSARIAL_HELPER_PATH = '/helper'
export const CRIME_ANALYSIS_PATH = '/analysis'
export const CRIME_RECOGNITION_PATH = '/recognition'
export const GLOVE_PATH = '/glove'
